// extracted by mini-css-extract-plugin
export default {"gallery":"hdPZw ZdH1P","slide":"ZKM4H"};